<div class="card custom-card overflow-hidden">
    <div class="card-header border-bottom-0">
        <div class="row row-sm justify-content-between">
            <div class="title border-bottom">
                <span class="ttl">
                    Vacante de <b class="text-primary">{{vacancy.title}}</b>
                </span>
            </div>
        </div>
    </div>
    <div class="card-body pl-0 pt-1">
        <div class="desc title text-center mb-1 mt-1">
            <span class="text-primary sttl">Disponibilidad</span>
        </div>
        <div class="desc mb-1 text-center">
            <b>Del {{vacancy?.date_start | moment:'ll'}} al {{vacancy?.date_end | moment:'ll'}}</b>
        </div>
        <div class="desc text-center title mb-1">
            <span class="text-primary sttl">Descripcion</span>
        </div>
        <div class="desc mb-1">
            {{vacancy.description}}
        </div>
        <div class="desc text-center title" *ngIf="vacancy.requirements?.length">
            <span class="text-primary sttl">Requisitos</span>
        </div>
        <div class="desc text-center title" *ngIf="vacancy.requirements?.length">
            <ul class="requerimientos">
                <li *ngFor="let req of vacancy.requirements">
                    {{req}}
                </li>
            </ul>
        </div>
    </div>
    <div class="card-footer bg-white text-center">
        <button class="btn btn-warning " (click)="confirm()">
            <span class="secondary">Ver proceso de seleccion</span>
        </button>
    </div>
</div>